import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { SPECIES } from "@/data/content";
import { motion } from "framer-motion";

export default function Species() {
  return (
    <section id="species" className="relative py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading number="05" eyebrow="Species Focus" title="Shrimp & crab — high-value by design."
            subtitle="Our aquaculture program centres on two high-value species, planned for RAS-assisted, high-tech farming with a zero-waste approach." />
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 max-w-4xl">
          {SPECIES.map((s, i) => (
            <motion.div
              key={s.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.09 }}
              className="group relative overflow-hidden rounded-3xl border border-white/10"
              data-testid={`species-card-${i}`}
            >
              <img src={s.image} alt={s.name} className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030D18] via-[#030D18]/40 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                <h3 className="font-display text-lg font-bold text-white">{s.name}</h3>
                <p className="mt-1 text-sm text-slate-300 opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
                  {s.note}
                </p>
              </div>
              <span className="absolute top-4 right-4 h-2 w-2 rounded-full bg-cyan-400 shadow-[0_0_12px_rgba(0,240,255,0.8)]" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
